import { createLayerStack } from "./layers";

/**
 * **One** layer stack and **one** Escape listener for the whole console (§7.6).
 *
 * Failure mode of a listener per window: `stopPropagation` stops an event
 * reaching other TARGETS, not other listeners on the same one, so four windows
 * all answer one Escape and a reader stepping back one loses the whole stack.
 */
export const layerStack = createLayerStack();

/**
 * Bubble phase, deliberately.
 *
 * Failure mode of a capture-phase listener, measured in Premier: it took Escape
 * from a right-click menu over the register behind an undocked panel — the menu
 * stood there while the panel closed underneath it. On the bubble phase the menu
 * has already had the key and `defaultPrevented` says so.
 *
 * AG Grid is the other claimant: it closes its own popups on Escape without
 * marking the event, so `agPopupIsOpen()` is what abstains for it.
 */
export function installEscapeListener(): () => void {
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== "Escape" || event.defaultPrevented) return;
    if (agPopupIsOpen()) return;
    if (layerStack.escape()) event.preventDefault();
  };
  document.addEventListener("keydown", onKeyDown);
  return () => document.removeEventListener("keydown", onKeyDown);
}

/** A cell editor, an open filter popup or a column menu owns the key while it is up. */
export function agPopupIsOpen(): boolean {
  return document.querySelector(".ag-popup, .ag-menu, .ag-filter, .ag-cell-inline-editing") !== null;
}
